var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6471 12.2353V3.35119L15.8403 1.15797L14.8421 0.159719L12.6488 2.35294H3.76472V0H2.35294V2.35294H0V3.76469H2.35294V13.647H12.2353V16H13.647V13.6471H16V12.2353H13.6471V12.2353ZM3.76472 3.76472H11.2371L3.76472 11.237V3.76472ZM12.2353 12.2353H4.76297L12.2353 4.76294V12.2353H12.2353Z",
    fill: "#262A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.433da16ef1b7d10e2287733477b59264.svg";
export { ForwardRef as ReactComponent };